import heroSplash from "../assets/hero-splash.jpg";

export const homeContent = {
  hero: {
    eyebrow: "AVUX Consulting",
    title:
      "Applying human-centered design to help oragnizations achieve their mission-critical goals.",
    description:
      "25+ years designing complex applications, workflows, and AI-powered experiences.",
    primaryCta: {
      label: "Schedule a Working Session",
      href: "#contact",
    },
    secondaryCta: {
      label: "View Case Studies",
      href: "#case-studies",
    },
    proofPoints: [
      "$150M+ revenue impact",
      "Risk & compliance UX specialist",
      "Government, healthcare, public safety, enterprise",
    ],
    backgroundImage: heroSplash,
  },
  pillars: [
    {
      title: "Product & UX Strategy",
      description:
        "Vision, workflows, and UI that reduce friction and increase measurable performance.",
    },
    {
      title: "AI Experience Design",
      description:
        "LLM-powered, intent-based, and decision-support interfaces with real governance.",
    },
    {
      title: "UXDevOps & Design Systems",
      description:
        "Accessible component libraries, Storybook integration, Figma → code pipelines.",
    },
  ],
  sectors: [
    {
      name: "Government & Public Safety",
      outcome: "Faster incident response and operational readiness.",
      image:
        "https://images.unsplash.com/photo-1670875329379-de986110c8ea?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    },
    {
      name: "Healthcare & Community Services",
      outcome: "Higher engagement and better continuity of care.",
      image:
        "https://images.unsplash.com/photo-1747224317356-6dd1a4a078fd?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    },
    {
      name: "Enterprise Risk & Compliance",
      outcome: "Shorter cycle times and fewer audit findings.",
      image:
        "https://images.unsplash.com/photo-1657727534685-36b09f84e193?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    },
    {
      name: "AI-Enabled Products & Platforms",
      outcome: "Increased self-service and faster analysis.",
      image:
        "https://images.unsplash.com/photo-1531403009284-440f080d1e12?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    },
  ],
  caseStudies: [
    {
      title: "COOP Management Platform",
      subtitle: "Public Safety Continuity",
      metric:
        "Reduced COOP plan update time, improved audit readiness, higher incident preparedness.",
      image:
        "https://images.unsplash.com/photo-1731846584223-81977e156b2c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1000",
    },
    {
      title: "Automated Crash & Incident Reporting",
      subtitle: "Law Enforcement",
      metric:
        "Reduced report completion time, improved data quality, increased downstream revenue capture.",
      image:
        "https://images.unsplash.com/photo-1698306642516-9841228dcff3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1000",
    },
    {
      title: "Compliance Workflow Redesign",
      subtitle: "Enterprise",
      metric:
        "Faster approvals, fewer escalations, measurable reduction in compliance cycle time.",
      image:
        "https://images.unsplash.com/photo-1581089778998-5266350efc71?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1000",
    },
    {
      title: "Mirror Match / Neurodiverse AI Experience",
      subtitle: "Healthcare / Community",
      metric:
        "Increased engagement, improved emotional recognition outcomes.",
      image:
        "https://images.unsplash.com/photo-1645685491865-42a4fbbc9912?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1000",
    },
  ],
  howItWorks: {
    steps: [
      {
        number: "1",
        title: "Diagnose the real operational problem",
        description:
          "We map workflow reality, stakeholders, and constraints to pinpoint the friction that matters most.",
      },
      {
        number: "2",
        title: "Design and test workflows + interfaces",
        description:
          "Prototypes, AI flows, and usability feedback loops de-risk decisions before rollout.",
      },
      {
        number: "3",
        title: "Launch with metrics and guardrails",
        description:
          "We ship with measurable targets and governance to sustain adoption.",
      },
    ],
    cta: {
      label: "See Our Approach",
      href: "#approach",
    },
  },
  kpiStrip: [
    "Time-to-complete critical workflows",
    "Compliance audit prep time",
    "Error/defect rate in key forms & flows",
    "User adoption & task success rate",
    "Revenue captured per transaction / case",
  ],
  socialProof: {
    quotes: [
      {
        quote:
          "AVUX translated complex compliance workflows into screens our teams can actually use under pressure.",
        attribution: "Chief Risk Officer, Enterprise Financial Services",
      },
    ],
    badges: [
      "Trusted in public safety, healthcare, risk & compliance environments",
      "25+ years in mission-critical UX & AI",
    ],
  },
  finalCta: {
    title: "Bring AVUX into your next mission-critical initiative.",
    button: {
      label: "Request a Strategy Call",
      href: "#contact",
    },
  },
};
